import React from 'react'
import { Colors } from '../../../theme'

const IconDrug = (props) => {
  const color = props.altcolor === true ? Colors.Palette.whiteColor : Colors.Palette.primaryColor
  const altColor = props.altcolor ? Colors.Palette.primaryColor : Colors.Palette.whiteColor
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" width="70" height="70">
      <defs>
        <style>{`.cls-1{fill:none;}.cls-2{fill:${color};}.cls-3{fill:${altColor};}`}</style>
      </defs>
      <title>Drug</title>
      <g id="Rx">
        <rect className="cls-1" x="-13" y="-2" width="192" height="192" />
      </g>
      <g id="Pill">
        <rect id="Bounding_Box" data-name="Bounding Box" className="cls-1" width="192" height="192" />
        <path className="cls-2" d="M113.38,153a24.07,24.07,0,0,0,34,0l5.65-5.65a24.07,24.07,0,0,0,0-34L118.63,79,79,118.63Z" />
        <path className="cls-2" d="M45.5,39.85,39.85,45.5a24.06,24.06,0,0,0,0,33.94L73.37,113,113,73.37,79.44,39.85A24.06,24.06,0,0,0,45.5,39.85Z" />
        <polygon className="cls-3" points="76.61 116.21 79.03 118.63 118.63 79.03 116.21 76.61 112.97 73.37 73.37 112.97 76.61 116.21" />
      </g>
    </svg>
  )
}

export default IconDrug



// WEBPACK FOOTER //
// ./src/assets/images/svg/Icon-Drug.js